import {BaseContainerModel} from '../base-container.model';
import {bl_fi_country_city_postal_code_RowClass} from '../../dbschema';

export class CountryCityPostalCodeContainerModel extends BaseContainerModel {
  bl_fi_country_city_postal_code: bl_fi_country_city_postal_code_RowClass = new bl_fi_country_city_postal_code_RowClass();
}
